import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useSeo } from "@/lib/useSeo";

export default function Oeuvres() {
  const [list, setList] = useState([]);
  useSeo("Résumés des œuvres au programme · collège et lycée · SUX1",
    "Résumés gratuits de 20 grands classiques étudiés au collège et au lycée : Candide, Le Cid, Phèdre, L'Avare, Germinal, Le Horla… Personnages, thèmes, citations.");
  useEffect(() => { fetch("/oeuvres/index.json").then((r) => r.json()).then(setList).catch(() => setList([])); }, []);

  return (
    <div className="min-h-screen bg-card" data-testid="oeuvres-page">
      <div className="max-w-5xl mx-auto px-6 md:px-10 py-14 lg:py-20">
        <div className="sux-marker mb-4">Bibliothèque gratuite · collège · lycée</div>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight leading-[0.95] mb-5" style={{ fontFamily: "Outfit" }}>
          Résumés des œuvres<br /><span className="text-[#002FA7]">au programme.</span>
        </h1>
        <p className="text-base md:text-lg text-muted-foreground max-w-2xl mb-10">
          20 grands classiques : résumé court, résumé par partie, personnages, thèmes, citations et l'essentiel à retenir pour le brevet ou le bac.
        </p>
        <div className="grid sm:grid-cols-2 gap-px bg-border border border-border" data-testid="oeuvres-list">
          {list.map((w) => (
            <Link key={w.slug} to={`/oeuvres/${w.slug}`} data-testid={`oeuvre-link-${w.slug}`}
              className="group bg-card p-5 flex items-center justify-between gap-4 hover:bg-[#002FA7]/5 transition-colors">
              <span>
                <span className="block font-black text-lg tracking-tight" style={{ fontFamily: "Outfit" }}>{w.title}</span>
                <span className="block text-sm text-muted-foreground">{w.author} · {w.year} · {w.genre}</span>
              </span>
              <ArrowRight className="w-4 h-4 text-[#002FA7] shrink-0 transition-transform group-hover:translate-x-1" />
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
